var render, staticRenderFns
import script from "./CompanyEditModuleMetaData.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModuleMetaData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34bf7260')) {
      api.createRecord('34bf7260', component.options)
    } else {
      api.reload('34bf7260', component.options)
    }
    
  }
}
component.options.__file = "src/components/company/CompanyEditModuleMetaData.vue"
export default component.exports